(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['./DataService',
      'app/demographics/demographicsCollection',
      'app/secure-message/secureMessageCollection',
      'app/appointment/appointmentCollection',
      'app/location/locationCollection',
      'app/insurance/patientInsuranceCollection',
      'app/visit/visitCollection',
      'app/appointment/specificAppointmentFeatureConfigCollection',
      'app/payment-method/storedPaymentMethodCollection',
      'app/insurance/insurancePolicyCollection',
      'app/insurance/insurancePolicyDetailsCollection',
      'app/printable/printableCollection',
      'app/tablet/tabletCollection',
      'app/branding-config/image/imageReferenceCollection',
      'app/branding-config/css/cssVariableCollection',
      'app/document/documentCollection',
      'app/questionnaire/surveyResponseCollection'
    ], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(
      require('./DataService'),
      require('./../demographics/demographicsCollection'),
      require('./../secure-message/secureMessageCollection'),
      require('./../appointment/appointmentCollection'),
      require('./../location/locationCollection'),
      require('./../insurance/patientInsuranceCollection'),
      require('./../visit/visitCollection'),
      require('./../appointment/specificAppointmentFeatureConfigCollection'),
      require('./../payment-method/storedPaymentMethodCollection'),
      require('./../insurance/insurancePolicyCollection'),
      require('./../insurance/insurancePolicyDetailsCollection'),
      require('./../printable/printableCollection'),
      require('./../tablet/tabletCollection'),
      require('./../branding-config/image/imageReferenceCollection'),
      require('./../branding-config/css/cssVariableCollection'),
      require('./../document/documentCollection'),
      require('./../questionnaire/surveyResponseCollection')
    );
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (
      DataService,
      demographicsCollection,
      secureMessageCollection,
      appointmentCollection,
      locationCollection,
      patientInsuranceCollection,
      visitCollection,
      specificAppointmentFeatureConfigCollection,
      storedPaymentMethodCollection,
      insurancePolicyCollection,
      insurancePolicyDetailsCollection,
      printableCollection,
      tabletCollection,
      imageReferenceCollection,
      cssVariableCollection,
      documentCollection,
      surveyResponseCollection
    ) {
  'use strict';

  return new DataService({
    demographics: demographicsCollection,
    secureMessage: secureMessageCollection,
    appointment: appointmentCollection,
    location: locationCollection,
    patientInsurance: patientInsuranceCollection,
    printable: printableCollection,
    insurancePolicy: insurancePolicyCollection,
    insurancePolicyDetails: insurancePolicyDetailsCollection,
    imageReference: imageReferenceCollection,
    visit: visitCollection,
    specificAppointmentFeatureConfigCollection: specificAppointmentFeatureConfigCollection,
    storedPaymentMethod: storedPaymentMethodCollection,
    tablet: tabletCollection,
    cssVariables: cssVariableCollection,
    document: documentCollection,
    surveyResponse: surveyResponseCollection
  });
}));
